// extracted by mini-css-extract-plugin
export var container = "_4f-0";
export var error = "_4f-9";
export var label = "_4f-5";
export var light = "_4f-6";
export var md = "_4f-3";
export var sm = "_4f-2";
export var thin = "_4f-8";
export var thinBold = "_4f-7";
export var vertical = "_4f-4";
export var xs = "_4f-1";